module.exports = __webpack_public_path__ + "img/download-windows-app-btn.4745bfee.png";